import { RootRoute } from "#src/routes/root";
import { RoutePath } from "#src/utils/route";

export const InvestigationsRoutePath = RootRoute.concat(
  new RoutePath({
    path: "/investigations",
    title: "Investigations",
  })
);
